export const VALUES_FIELD_NAME = [
    'All',
    'Landscape',
    'Landscape (left)',
    'Landscape (right)',
    'Portrait',
    'Portrait (up)',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];

export type TYPES_FIELD_BYTEVALUE = 0 | 1 | 2 | 4 | 8;

export const VALUES_FIELD_BYTEVALUE: Record<TYPES_FIELD_NAME, TYPES_FIELD_BYTEVALUE> = {
    All: 0,
    Landscape: 0,
    'Landscape (left)': 1,
    'Landscape (right)': 2,
    Portrait: 4,
    'Portrait (up)': 8,
} as const;
